import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Representante} from './model/representante';
import {AppConfigService} from 'src/app/app-config.service';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class IntranetService {

  private url_obtenerOrganizador = '';
  private url_obtenerOrganizadores = '';
  private url_obtenerParametro = '';
  private url_buscarAsamblea = '';
  private url_guardarPlantilla = '';
  private url_obtenerOpciones = '';
  private url_guardarAsamblea = '';
  private url_modificarAsamblea = '';
  private url_obtenerPerfiles = '';
  private url_guardarAcceso = '';
  private url_editarUsuario = '';
  private url_obtenerAcceso = '';
  private url_obtenerTitular = '';
  private url_obtenerPersona = '';
  private url_guardarRepresentante = '';
  private url_listarRepresentante = '';
  private url_eliminarRepresentante = '';
  private url_iniciarImportacion = '';
  private url_subirArchivo = '';
  private url_enviarCorreo = '';
  private url_listarResultados = '';
  private url_listarAsamblea = '';
  private url_modificarEstadoAsamblea = '';
  private url_downloadParticipesFondo = '';
  private url_uploadParticipesFondo = '';
  private url_modificarBloqueoAsamblea = '';

  constructor(
    public _http: HttpClient,
    private appConfigService: AppConfigService
  ) {
    this.loadConfig();
  }

  loadConfig() {
    const conf = this.appConfigService.getConfig();
    this.url_obtenerOrganizador = conf.apiEndpoint + '/asamblea/traerOrganizador';
    this.url_obtenerOrganizadores = conf.apiEndpoint + '/asamblea/traerOrganizadores';
    this.url_obtenerParametro = conf.apiEndpoint + '/parametros/traerParametros';
    this.url_buscarAsamblea = conf.apiEndpoint + '/asamblea/buscarAsamblea';
    this.url_listarAsamblea = conf.apiEndpoint + '/asamblea/listarAsamblea';
    this.url_guardarPlantilla = conf.apiEndpoint + '/asamblea/insertaOpcion';
    this.url_obtenerOpciones = conf.apiEndpoint + '/asamblea/listarOpciones';
    this.url_guardarAsamblea = conf.apiEndpoint + '/asamblea/guardarAsamblea';
    this.url_modificarAsamblea = conf.apiEndpoint + '/asamblea/modificarAsamblea';
    this.url_obtenerPerfiles = conf.apiEndpoint + '/user/buscarPerfiles';
    this.url_guardarAcceso = conf.apiEndpoint + '/acceso/guardarUsuario';
    this.url_editarUsuario = conf.apiEndpoint + '/user/editarUsuario';
    this.url_obtenerAcceso = conf.apiEndpoint + '/user/buscarUsuario';
    this.url_obtenerTitular = conf.apiEndpoint + '/representante/buscarTitular';
    this.url_obtenerPersona = conf.apiEndpoint + '/persona/buscarPersona';
    this.url_guardarRepresentante = conf.apiEndpoint + '/representante/guardarRepresentante';
    this.url_listarRepresentante = conf.apiEndpoint + '/representante/listarRepresentante';
    this.url_eliminarRepresentante = conf.apiEndpoint + '/representante/eliminarRepresentante';
    this.url_iniciarImportacion = conf.apiEndpoint + '/masivo/inserta';
    this.url_subirArchivo = conf.apiEndpoint + '/file/uploadFile';
    this.url_enviarCorreo = conf.apiEndpoint + '/mail/sendMail';
    this.url_listarResultados = conf.apiEndpoint + '/pregunta/estadisticaResultados';
    this.url_modificarEstadoAsamblea = conf.apiEndpoint + '/asamblea/modificarEstadoAsamblea';
    this.url_modificarBloqueoAsamblea = conf.apiEndpoint + '/asamblea/modificarBloqueoAsamblea';
    this.url_downloadParticipesFondo = conf.apiEndpoint + '/participes-fondo/download';
    this.url_uploadParticipesFondo = conf.apiEndpoint + '/participes-fondo/upload';
  }

  obtenerOrganizador(_idAsamblea: number) {
    return this._http.post(this.url_obtenerOrganizador, {valor: _idAsamblea, nombre: ''}).toPromise();
  }

  listarOrganizadores() {
    return this._http.post(this.url_obtenerOrganizadores, {}).toPromise();
  }

  obtenerParametro(_tipoParametro: string) {
    return this._http.post(this.url_obtenerParametro, {nombre: '', valor: _tipoParametro}).toPromise();
  }

  listarAsamblea(object: Object) {
    return this._http.post(this.url_listarAsamblea, object).toPromise();
  }

  buscarAsamblea(_idAsamblea: number) {
    return this._http.post(this.url_buscarAsamblea, {nombre: '', valor: _idAsamblea}).toPromise();
  }

  guardarPlantilla(_plantilla: string) {
    return this._http.post(this.url_guardarPlantilla, {
      nombre: '', valor: _plantilla
    }).toPromise();
  }

  guardarAsamblea(object: Object) {
    return this._http.post(this.url_guardarAsamblea, object).toPromise();
  }
/*
  modificarAsamblea(object: Object) {
    return this._http.post(this.url_modificarAsamblea, object).toPromise();
  }
*/
  modificarAsamblea(formData: FormData) {
  return this._http.post(this.url_modificarAsamblea, formData).toPromise();
}

  obtenerOpciones() {
    return this._http.post(this.url_obtenerOpciones, {}).toPromise();
  }

  listarPerfiles() {
    return this._http.post(this.url_obtenerPerfiles, {}).toPromise();
  }

  guardarAcceso(object: Object) {
    return this._http.post(this.url_guardarAcceso, object).toPromise();
  }

  editarAcceso(object: Object) {
    return this._http.post(this.url_editarUsuario, object).toPromise();
  }

  obtenerAcceso(usuario: string) {
    return this._http.post(this.url_obtenerAcceso, {
      nombre: usuario,
      valor: usuario
    }).toPromise();
  }

  buscarTitular(_representante: Representante) {
    return this._http.post(this.url_obtenerTitular, {
      tipoDocumento: _representante.tipoDocumento,
      numeroDocumento: _representante.numeroDocumento,
      idAsamblea: _representante.idAsamblea
    }).toPromise();
  }

  buscarPersona(tipoDocumento: string, numeroDocumento: string) {
    return this._http.post(this.url_obtenerPersona, {
      tipoDocumento,
      numeroDocumento
    }).toPromise();
  }

  guardarRepresentante(_representante: Representante) {
    return this._http.post(this.url_guardarRepresentante, _representante).toPromise();
  }

  listarRepresentantes(_idAsamblea: number) {
    return this._http.post(this.url_listarRepresentante, {
      valor: _idAsamblea,
      nombre: ''
    }).toPromise();
  }

  eliminarRepresentante(_idFoto: number) {
    return this._http.post(this.url_eliminarRepresentante, {
      valor: _idFoto,
      nombre: ''
    }).toPromise();
  }

  iniciarMigracion(_usuario: string) {
    return this._http.post(this.url_iniciarImportacion, {
      valor: _usuario,
      nombre: _usuario
    }).toPromise();
  }

  listarResultados(idAsamblea: number) {
    return this._http.post(this.url_listarResultados, {
      nombre: idAsamblea,
      valor: idAsamblea
    }).toPromise();
  }

  subirArchivo(form: FormData) {
    return this._http.post(this.url_subirArchivo, form).toPromise();
  }

  enviarCorreoAdjunto(idAsamblea: number, adjunto: string) {
    return this._http.post(this.url_enviarCorreo, {
      modo: 'U',
      reporte: adjunto,
      idAsamblea
    }).toPromise();
  }

  modificarEstadoAsamblea(idAsamblea: number, estado: string) {
    return this._http.post(this.url_modificarEstadoAsamblea, {
      idAsamblea: idAsamblea,
      estado: estado
    }).toPromise();
  }

  downloadParticipesFondo(fondo: string, fecha: string): Observable<Blob> {
    return this._http.post(this.url_downloadParticipesFondo, { fondo, fecha }, { responseType: 'blob' });
  }

  uploadParticipesFondo(request: { numeroAsamblea: string, fecha: string, codigoAlterno: string}) {
    return this._http.post(this.url_uploadParticipesFondo, request).toPromise();
  }

  modificarBloqueoAsamblea(idAsamblea: number, nuevoBloqueo: string) {
    return this._http.post(this.url_modificarBloqueoAsamblea, {
      idAsamblea: idAsamblea,
      bloquearVoto: nuevoBloqueo
    }).toPromise();
  }
}
